module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_2023_m-48bc141f127f82470936ae542a6372c3.png";